import React from "react";
import { services } from "../constants";

/* ═══════════════════════════════════════════════════════════
   ABOUT — Overview
   Line reveals · liquid fade cards · gold spotlight
   ═══════════════════════════════════════════════════════════ */

const ServiceCard = ({ title, icon, index }) => (
  <div
    className="lux-card reveal-fade p-8 flex flex-col items-center text-center gap-6 min-h-[220px] justify-center"
    data-parallax={0.05 + index * 0.02}
  >
    <img
      src={icon}
      alt={title}
      className="w-14 h-14 object-contain opacity-70"
      loading="lazy"
    />
    <h3 className="font-grotesk text-sm tracking-[0.2em] uppercase text-silver-200">
      {title}
    </h3>
  </div>
);

const About = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl">
        <p className="lux-eyebrow mb-6">Introduction</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Overview</span>
          </span>
        </h2>
      </div>

      <div className="mt-12 max-w-3xl">
        <p className="lux-body reveal-fade">
          A Software engineer with close to 4 years of expertise in frontend
          development, specializing in ReactJS, JavaScript, TypeScript, and
          Adobe Target for personalized web experiences. Proficient at
          building high-performance, user-centric solutions by leveraging
          modern web technologies and data-driven decision-making. Keen
          about scalable architecture and optimizing user engagement.
        </p>
        <p className="lux-body mt-6 reveal-fade">
          Download my{" "}
          <a
            href="https://drive.google.com/drive/folders/1-TCn79J9C78aJJhbQFVhD7T4oG3OSXu6?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="text-champagne-400 hover:text-champagne-300 underline underline-offset-4 transition-colors duration-500"
          >
            resume here
          </a>
          .
        </p>
      </div>

      <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((service, index) => (
          <ServiceCard key={service.title} {...service} index={index} />
        ))}
      </div>
    </div>
  );
};

export default About;